import { Swiper, SwiperSlide } from "swiper/react";
import cn from "classnames";
import { PRODUCT_SLUG } from "@types";
import { Button } from "@shared/components";
import { BUTTON_SIZE, BUTTON_VARIANT } from "@shared/components/button/types";
import ArrowLeft2Icon from "@svg/new-design/arrow-left2";
import classNames from "classnames";
import useHomeTabs from "@features/home/hooks/useHomeTabs";
import { ICardTab } from "types/card-tab";

// this should be removed in future - made this way to skip api change for now
export const homeTempTitleFormatter = (title: string) => {
  if (!title || typeof title !== "string") return "";
  else if (title === "آموزش‌های پرمخاطب") return "محبوب‌ترین آموزش‌ها";
  else if (title === "آموزش‌های پرمخاطب رایگان")
    return "محبوب‌ترین آموزش‌های رایگان";
  else return title;
};

interface Props {
  slug: PRODUCT_SLUG;
  // eslint-disable-next-line no-unused-vars
  onClick?: (slug: PRODUCT_SLUG, category: ICardTab) => void;
  tabs?: ICardTab[];
  title?: string;
  showMoreLink?: string;
}

const TabHeader: React.FC<Props> = ({
  slug,
  onClick,
  tabs = [],
  title,
  showMoreLink,
}) => {
  const {
    listRef,
    activeRef,
    indicatorRef,
    setSwiper,
    activeId,
    updateIndicator,
    handleTabClick,
    hasTabs,
  } = useHomeTabs({ slug, onClick, tabs });

  return (
    <div
      className={classNames(
        !hasTabs ? "py-2" : "",
        "w-full flex min-h-14 items-center justify-between rounded-8 mb-6 bg-fds-secondary pr-5 pl-4"
      )}
    >
      {title && (
        <p className="headline-lg text-fds-primary min-w-fit">
          {homeTempTitleFormatter(title)}
        </p>
      )}

      {hasTabs && (
        <>
          {title && (
            <div className="w-px bg-fds-default border-r border-fds-default h-7 mx-3" />
          )}
          <div
            ref={listRef}
            role="tablist"
            className="relative overflow-x-auto w-full pl-2 gap-x-2 py-2.5 flex no-scrollbar"
          >
            <Swiper
              slidesPerView="auto"
              className="swiperHeader  w-full flex gap-x-2"
              spaceBetween={8}
              onTransitionEnd={updateIndicator}
              allowTouchMove={true}
              onSwiper={setSwiper}
            >
              {tabs.map((tab) => (
                <SwiperSlide key={tab.id} onClick={() => handleTabClick(tab)}>
                  <div
                    ref={tab.id === activeId ? activeRef : null}
                    role="tab"
                    aria-selected={tab.id === activeId}
                    className={cn(
                      "rounded-4 cursor-pointer flex items-center px-2 py-1 justify-center h-full tap-highlight-none"
                    )}
                  >
                    <p className="body-md text-fds-primary">{tab.name}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div
              ref={indicatorRef}
              className="absolute top-2 h-9 bg-fds-primary shadow-primary-sm rounded-4 transition-all duration-500"
              aria-hidden="true"
            />
          </div>
        </>
      )}

      {showMoreLink && (
        <Button
          endIcon={<ArrowLeft2Icon />}
          variant={BUTTON_VARIANT.TEXT_ACTION}
          size={BUTTON_SIZE.LARGE}
          linkClassName="min-w-fit"
          href={showMoreLink}
        >
          دیدن همه
        </Button>
      )}
    </div>
  );
};

export default TabHeader;
